import React from 'react';
import { Link } from "react-router-dom";
import AnimatedNumber from 'components/ui/animatednumber';

export default function Resultados() {
  return (
    <div className="resultados">
      <h4 className='title-ico'><i></i><span>Resultados del Programa</span></h4>
      <div className="data">
        <div>
          <span>Capacitaciones en territorio:</span>
          <strong><AnimatedNumber targetNumber={179} /></strong>
        </div>
        <div>
          <span>Capacitaciones virtuales:</span>
          <strong><AnimatedNumber targetNumber={18} /></strong>
        </div>
        <div>
          <span>Total de personas capacitadas:</span>
          <strong><AnimatedNumber targetNumber={7258} /></strong>
        </div>
      </div>
      <Link to='/programa-en-numeros' className='btn-verde'>Ver todos</Link>
    </div>
  );
}